<div class="ai-assist-widget"
     [class.expanded]="isExpanded"
     [class.minimized]="isMinimized"
     [class.bottom-right]="position === 'bottom-right'"
     [class.bottom-left]="position === 'bottom-left'">

  <!-- FAB Button -->
  <button class="ai-fab"
          (click)="toggle()"
          *ngIf="!isExpanded || isMinimized"
          [attr.aria-label]="isMinimized ? 'Restore AI Assistant' : 'Open AI Assistant'">
    <span class="icon" *ngIf="!hasActiveWorkflow">?</span>
    <span class="icon" *ngIf="hasActiveWorkflow">{{ currentStep }}/{{ totalSteps }}</span>
    <span class="pulse" *ngIf="hasActiveWorkflow"></span>
  </button>

  <!-- Expanded Chat Panel -->
  <div class="chat-panel" *ngIf="isExpanded && !isMinimized">
    <!-- Header -->
    <div class="chat-header">
      <span class="header-title">
        <span class="icon-text">🤖</span>
        AI Assistant
      </span>
      <div class="header-actions">
        <button class="header-btn minimize-btn"
                (click)="minimize()"
                *ngIf="hasActiveWorkflow"
                aria-label="Minimize">
          <span>─</span>
        </button>
        <button class="header-btn close-btn"
                (click)="close()"
                aria-label="Close">
          <span>×</span>
        </button>
      </div>
    </div>

    <!-- Chat Body -->
    <div class="chat-body">
      <!-- Messages -->
      <div class="messages-container">
        <div class="message" *ngFor="let msg of messages" [class]="'message-' + msg.type">
          <div class="message-content">{{ msg.text }}</div>
          <div class="message-time">{{ msg.timestamp | date: 'shortTime' }}</div>
        </div>

        <!-- Loading indicator -->
        <div class="message message-assistant" *ngIf="isLoading">
          <div class="message-content">
            <span class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
        </div>
      </div>

      <!-- Workflow Progress -->
      <div class="workflow-progress" *ngIf="activeSession && activeSession.status === 'active'">
        <div class="progress-info">
          <span class="progress-text">Step {{ currentStep }} of {{ totalSteps }}</span>
          <button class="cancel-btn" (click)="cancelWorkflow()">Cancel</button>
        </div>
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="(currentStep / totalSteps) * 100"></div>
        </div>
      </div>
    </div>

    <!-- Quick Suggestions -->
    <div class="suggestions" *ngIf="!activeSession && showSuggestions && quickSuggestions.length > 0">
      <div class="suggestions-title">Quick suggestions:</div>
      <button class="suggestion-btn"
              *ngFor="let suggestion of quickSuggestions"
              (click)="submitQuery(suggestion)">
        {{ suggestion }}
      </button>
    </div>

    <!-- Input -->
    <div class="chat-input">
      <input
        type="text"
        class="input-field"
        [(ngModel)]="userInput"
        (keyup.enter)="submitQuery(userInput)"
        placeholder="Ask me how to do something..."
        [disabled]="isLoading || !!activeSession"
        aria-label="Chat input"
      />
      <button class="send-btn"
              (click)="submitQuery(userInput)"
              [disabled]="!userInput || isLoading || !!activeSession"
              aria-label="Send message">
        <span class="send-icon">➤</span>
      </button>
    </div>
  </div>
</div>
